/// <amd-module name="VSS/Features/Charts/Internal/LegendLabelFormatter" />
import * as StringUtilities from "./StringUtilities";

import { isNumeric } from "./CompatUtilities";

/** Used for formatting legend labels. */
export class LegendLabelFormatter {
    /**
     * Obtains function for formatting legend labels.
     * @param [formatLength] - Defines the max length a label can be before being truncated. If omitted no truncation is performed.
     * @returns a function used by highcharts to format legend labels.
     */
    public static getFormatter(formatLength?: number): () => string {
        // 'this' keyword in the callback function refers to the series object (or point object in pie charts)
        return function() {
            let value = this.name;

            if (isNumeric(formatLength)) {
                value = StringUtilities.truncateString(value, formatLength);
            }

            return value;
        };
    }
}
